import type { APIResponse } from '@yourownmetric/shared'

import { apiSlice } from './apiSlice'

export interface ApiKeyRow {
    id: string
    projectId: string
    name: string
    keyPrefix: string
    scopes: string // JSON-encoded array
    rateLimit: number
    lastUsedAt: string | null
    expiresAt: string | null
    createdAt: string
    revokedAt: string | null
}

interface CreateApiKeyPayload {
    projectId: string
    name: string
    scopes: string[]
    rateLimit?: number
    expiresAt?: string
}

interface CreateApiKeyResponse {
    id: string
    name: string
    key: string // plaintext — shown only once
    keyPrefix: string
    scopes: string[]
    rateLimit: number
    expiresAt?: string
}

export const apiKeysApi = apiSlice.injectEndpoints({
    endpoints: builder => ({
        listApiKeys: builder.query<ApiKeyRow[], void>({
            query: () => '/api-keys',
            transformResponse: (res: APIResponse<ApiKeyRow[]>) => res.data!,
            providesTags: ['ApiKeys'],
        }),

        createApiKey: builder.mutation<CreateApiKeyResponse, CreateApiKeyPayload>({
            query: body => ({ url: '/api-keys', method: 'POST', body }),
            transformResponse: (res: APIResponse<CreateApiKeyResponse>) => res.data!,
            invalidatesTags: ['ApiKeys'],
        }),

        revokeApiKey: builder.mutation<{ id: string; revoked: boolean }, string>({
            query: keyId => ({ url: `/api-keys/${keyId}`, method: 'DELETE' }),
            transformResponse: (res: APIResponse<{ id: string; revoked: boolean }>) => res.data!,
            invalidatesTags: ['ApiKeys'],
        }),
    }),
})

export const { useListApiKeysQuery, useCreateApiKeyMutation, useRevokeApiKeyMutation } = apiKeysApi
